"use client";

// Utils
import st from "./index.module.scss";
import { GameType } from "@/domains/games/types";
import { useStore } from "@/hooks/use-store";
import { useEffect, useMemo } from "react";
import { useGameDemoInit } from "@/domains/games/hooks/use-game-demo-init";
import { useGameInit } from "@/domains/games/hooks/use-game-init";

type ModalGameMobileInitProps = {
  item: GameType;
  isDemo: boolean;
};

export default function ModalGameMobileInit({ item, isDemo }: ModalGameMobileInitProps) {
  const { user, modal } = useStore();
  const isRealActive = user && !isDemo;

  const gameDemoPayload = useMemo(
    () => ({
      gameId: item?.id,
      demo: isDemo,
    }),
    [item?.id, isDemo],
  );

  const { gameDemoUrl, onMutateGameDemoInit, errorGameDemoInit } = useGameDemoInit(gameDemoPayload);

  const gamePayload = useMemo(
    () => ({
      gameId: item?.id,
      demo: isDemo,
    }),
    [item?.id, isDemo],
  );

  const { gameUrl, onMutateGameInit, errorGameInit } = useGameInit(gamePayload);

  useEffect(() => {
    modal.setShowCloseButton(false);

    if (item?.id && isDemo) {
      onMutateGameDemoInit();
    } else if (item?.id && !isDemo) {
      onMutateGameInit();
    }
  }, [item?.id, isDemo]);

  return (
    <div className={st.game__wrapper}>
      {isRealActive && gameUrl && (
        <iframe allowFullScreen className={st.game__wrapper_frame} src={gameUrl}></iframe>
      )}
      {isDemo && gameDemoUrl && item.provider.demo && (
        <iframe allowFullScreen className={st.game__wrapper_frame} src={gameDemoUrl}></iframe>
      )}
      {(errorGameDemoInit || errorGameInit) && (
        <div className={st.game__wrapper_error}>Game Init Server Error</div>
      )}
      {(gameUrl || gameDemoUrl) && (
        <div className={st.game__wrapper_close}>
          <div
            className={st.game__wrapper_close__btn}
            onClick={() => {
              modal.closeModal();
            }}
          >
            <svg
              viewBox="0 0 14 14"
              fill="currentColor"
              width="18"
              height="100%"
              className={st.game__wrapper_close__icon}
            >
              <use href="/images/sprite.svg#close"></use>
            </svg>
          </div>
        </div>
      )}
    </div>
  );
}
